import {
  snapRound,
  type SnapRoundingOptions,
  SnapRoundingOptionsDecimal,
  SnapRoundingOptionsDecimalPercent,
  snapRoundPerUnit,
} from '@calculations/round/decimal';
import { dec, Decimal } from '@snap-types/types/decimal';

export function calculateUnitPriceFromGrossMargin(
  {
    unitCost,
    grossMargin,
  }: {
    unitCost: Decimal;
    grossMargin: Decimal;
  },
  roundingOptions: SnapRoundingOptions = SnapRoundingOptionsDecimal,
): Decimal {
  if (grossMargin.gte(dec('1'))) {
    throw new Error('Gross Margin cannot be greater than or equal to 1');
  }

  return snapRoundPerUnit(
    unitCost.dividedBy(dec('1').minus(grossMargin)),
    roundingOptions,
  );
}

export function calculateGrossMarginFromUnitPrice(
  {
    unitCost,
    unitPrice,
  }: {
    unitCost: Decimal;
    unitPrice: Decimal;
  },
  roundingOptions: SnapRoundingOptions = SnapRoundingOptionsDecimalPercent,
): Decimal {
  if (unitPrice.eq(dec('0'))) {
    throw new Error('Unit Price cannot be 0');
  }

  return snapRound(
    unitPrice.minus(unitCost).dividedBy(unitPrice),
    roundingOptions,
  );
}
